import { render, staticRenderFns } from "./comPager.vue?vue&type=template&id=209dcf2b&scoped=true&"
import script from "./comPager.vue?vue&type=script&lang=js&"
export * from "./comPager.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./comPager.vue?vue&type=style&index=0&id=209dcf2b&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "209dcf2b",
  "b11aec92"
  
)

export default component.exports